/**
 * The default zoom level for the map.
 */
export const DEFAULT_ZOOM = 8;

/**
 * The zoom level for the street view.
 */
export const STREET_VIEW_ZOOM = 15;

/**
 * The minimum zoom level for the map.
 */
export const MIN_ZOOM = 4;

/**
 * The maximum zoom level for the map.
 */
export const MAX_ZOOM = 22;
